import axios from './requestClient';

export const fetchApplication = (id) => {
  return axios.get(`/api/v1/Client/${id}`);
};

export const fetchApplications = () => {
  return axios.get('/api/v1/Client');
};
